import gql from 'graphql-tag';

export default gql`
    type ScreenSize {
        tablet: Boolean!
        desktop: Boolean!
    }

    extend type Query {
        screenSize: ScreenSize
    }

    extend type Mutation {
        utility_screenSize(tablet: Boolean!, desktop: Boolean!): ScreenSize!
    }
`;
